
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1896',
  depVersions: {
  "customer-portal-app": "static-1.1896",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "data-fetching-client": "static-1.9559",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.416",
  "growth-payments-core": "static-1.24995",
  "head-dlb": "static-1.4884",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5478",
  "hs-test-utils": "static-1.7895",
  "hub-http": "static-1.6102",
  "hub-http-shared-msw-handlers": "static-1.9687",
  "hubspot-dlb": "static-2.1828",
  "hubspot-prosemirror": "static-1.17876",
  "hubspot-url-utils": "static-1.4034",
  "HubStyleTokens": "static-2.11329",
  "I18n": "static-7.1598",
  "immutable": "static-2.76",
  "jasmine-runner": "static-1.6353",
  "payment-link-components": "static-1.23182",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6844",
  "quartz-core": "static-1.6063",
  "react": "static-7.183",
  "react-colorpicker": "static-2.10093",
  "react-dlb": "static-1.75",
  "react-utils": "static-2.5251",
  "rich-text-lib": "static-1.19625",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17803",
  "ui-components-test-utils": "static-1.5467",
  "UIComponents": "static-3.8276",
  "foundations-assets": "static-1.4726",
  "foundations-components": "static-1.7684",
  "foundations-theming": "static-1.4295",
  "foundations-theming-specialty": "static-1.2011",
  "framer-motion": "static-1.69",
  "history": "static-4.47",
  "metrics-js": "static-1.9522",
  "PortalIdParser": "static-2.377",
  "portals-platform-lib": "static-1.671",
  "quartz-config": "static-1.622",
  "quartz-routing": "static-1.274",
  "quick-fetch": "static-1.3817",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16537",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.8028",
  "styled-components": "static-2.87",
  "tanstack-table": "static-1.52",
  "ui-addon-draggable": "static-3.4652",
  "ui-addon-react-router-dom": "static-1.9428",
  "usage-tracker": "static-1.7219",
  "usage-tracker-anonymous": "static-1.5636",
  "usage-tracker-core": "static-1.7069",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3310",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3121",
  "quartz-webpack": "static-1.3068",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.79",
  "customer-data-objects": "static-1.7537",
  "frontend-preferences-client": "static-1.7807",
  "laboratory-lib": "static-3.7043",
  "onboarding-scopes": "static-1.6346",
  "rpc-client-utils": "static-1.4526",
  "ui-addon-opt": "static-4.8266",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.3006",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "ts-schema": "static-1.3982",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7573",
  "cssUtils": "static-1.764",
  "customer-data-ui-utilities": "static-1.9708",
  "HubStyle": "static-2.11637",
  "knowledge-content-types": "static-1.8438",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.519",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9770",
  "ui-addon-i18n": "static-1.11030",
  "ui-business-units-lib": "static-1.8922",
  "ui-shepherd-react": "static-3.10030",
  "video-components-external": "static-1.10868",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4208",
  "commerce-tours-lib": "static-1.5873",
  "customer-data-properties": "static-1.51099",
  "getting-started-shared-tasks": "static-1.18144",
  "growth-onboarding-reliability": "static-1.4970",
  "onboarding-tours": "static-1.16385",
  "reference-resolvers-lite": "static-1.7972",
  "sales-checkout-service-client": "static-1.3551",
  "ui-addon-iframeable": "static-1.8933",
  "user-context": "static-1.4983",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4555",
  "icons": "static-2.637",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.519",
  "quartz-head": "static-1.509",
  "quartz-test": "static-1.519",
  "quartz-tracking": "static-1.223",
  "ui-fonts": "static-1.591",
  "usage-tracker-container": "static-1.7209",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9312",
  "data-token-picker": "static-1.16196",
  "FileManagerLib": "static-1.38860",
  "property-translator": "static-1.5293",
  "atom": "static-1.4953",
  "merchandise-lib": "static-1.261",
  "purchase-motions-components": "static-1.5644",
  "salesImages": "static-1.522",
  "SharedI18nStrings": "static-1.181",
  "foundations-components-test-utils": "static-1.5167",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.96",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-components": "static-1.3953",
  "floating-ui": "static-1.53",
  "react-aria": "static-1.63",
  "trellis-assets": "static-1.1469",
  "bend-plugin-foundations-theming": "static-1.2778",
  "foundations-theming-base": "static-1.3280",
  "stylex": "static-1.29",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5633",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4356",
  "react-flip-move": "static-1.67",
  "bender-build-tools": "static-1.3041",
  "inbound-db-properties-service-client": "static-1.3749",
  "superstore": "static-1.4652",
  "chirp-fetch": "static-1.1765",
  "feedback-loader": "static-1.29061",
  "ai-components-ui-library": "static-1.8619",
  "ui-addon-video-player": "static-1.8579",
  "ui-coaching-tips": "static-1.28191",
  "sassPrefix": "static-1.153",
  "react-dnd-compat": "static-1.4502",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2377",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8049",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4534",
  "content-media-composition-data-lib": "static-1.11827",
  "content-media-compositions": "static-2.15834",
  "idb-keyval": "static-1.41",
  "immer": "static-1.33",
  "immerable": "static-1.4036",
  "magpie-lib": "static-1.5477",
  "magpie-types": "static-1.4937",
  "media-bridge-lib": "static-1.18716",
  "video-data-lib": "static-1.34526",
  "commerce-products-lib": "static-1.9099",
  "crm-message-bus": "static-1.42636",
  "growth-data-modal": "static-1.5246",
  "hubspot-apollo-client": "static-1.4762",
  "onboarding-tours-client": "static-1.4599",
  "calling-global-api": "static-1.64027",
  "calling-internal-common": "static-1.31185",
  "calling-lifecycle-internal": "static-1.65409",
  "calling-lifecycle-messages": "static-1.57703",
  "conditional-properties-service-client": "static-1.3701",
  "crm-links": "static-1.6157",
  "customer-data-objects-ui-components": "static-1.12900",
  "customer-data-property-utils": "static-1.7965",
  "external-options-client-types": "static-1.4062",
  "file-manager-components": "static-1.23220",
  "framework-data-schema-resolvers": "static-1.6758",
  "google-libphonenumber": "static-1.35",
  "hs-resources": "static-1.17",
  "inbound-db-meta-service-client": "static-1.3493",
  "inbounddb-objects-service-types": "static-1.4126",
  "meetings-icalendar-utils-lib": "static-1.514",
  "multi-currency-client-types": "static-1.3593",
  "object-builder-ui-client": "static-1.48325",
  "pipeline-validation-client-types": "static-1.3867",
  "property-value-citations": "static-1.1713",
  "pulse": "static-1.416",
  "smart-property-lib": "static-1.6343",
  "tiered-pricing": "static-1.980",
  "ui-addon-form-validation": "static-1.10875",
  "growth-onboarding-confetti": "static-1.2955",
  "growth-onboarding-next-action-utils": "static-1.1551",
  "navigation-components": "static-1.17584",
  "onboarding-tours-utils": "static-1.451",
  "ui-shepherd-tracker": "static-1.7411",
  "ui-universal-auth": "static-1.8810",
  "batch-promise": "static-1.1435",
  "navigation-messaging": "static-1.6911",
  "getting-started-shared-tasks-store": "static-1.17262",
  "hubspotter-http-shared-msw-handlers": "static-1.9685",
  "usage-tracker-session-replay": "static-1.4905",
  "audio-components": "static-1.5736",
  "FileManagerCore": "static-1.38719",
  "FileManagerImages": "static-1.36371",
  "video-components": "static-1.12871",
  "foundations-components-legacy": "static-1.709",
  "growth-monetization-service-types": "static-1.4382",
  "nav-client-types": "static-1.2240",
  "purchase-motions-api": "static-1.5647",
  "self-service-api": "static-1.10128",
  "signup-constants": "static-1.18617",
  "signup-ui-url-generator": "static-2.7922",
  "trials-service-types": "static-1.3783",
  "usage-tracker-public": "static-1.7030",
  "chatspot-core": "static-1.20744",
  "ContentUtils": "static-1.67934",
  "copilot-toolkit": "static-1.10782",
  "growth-onboarding-feedback-components": "static-1.6464",
  "reactive-lib": "static-1.607",
  "simple-logging-lib": "static-1.2934",
  "commerce-permissions": "static-1.648",
  "customer-data-tracking": "static-1.6766",
  "products-iframe-lib": "static-1.7584",
  "products-ui-components-shared-msw-handlers": "static-1.10069",
  "hubspot-apollo-cache": "static-1.221",
  "calling-error-reporting": "static-1.31191",
  "shared-worker-versioning": "static-1.10922",
  "calling-usage-tracker": "static-1.6425",
  "voice-sms-access-library": "static-1.525",
  "conversations-skeleton-state": "static-1.7132",
  "location-customization-utils-lib": "static-1.8850",
  "crm-pipelines-api-client-types": "static-1.4046",
  "framework-builder-read-service-client": "static-1.3912",
  "framework-data-schema-quick-fetch": "static-1.6663",
  "persist-promise": "static-1.3592",
  "directed-graph": "static-1.821",
  "event-emitter": "static-1.831",
  "fast-json-patch": "static-1.60",
  "breeze-intelligence-kit": "static-1.5446",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9770",
  "fsm": "static-1.3617",
  "policy-lib": "static-1.6664",
  "react-tinymce": "static-1.54886",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9833",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54012",
  "tinymce-plugins": "static-1.57126",
  "tinymce-themes": "static-1.55982",
  "growth-onboarding-next-action-components": "static-1.1579",
  "user-context-client": "static-1.4495",
  "nest": "static-1.105",
  "unified-auth-core-lib": "static-1.605",
  "amplitude-session-replay-browser": "static-1.57",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4415",
  "video-embed": "static-1.35360",
  "content-icons-ui": "static-1.2191",
  "social-insights-client-types": "static-1.21701",
  "eligibility-engine-service-types": "static-1.3064",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4691",
  "integrations-lib": "static-1.15705",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4146",
  "calling-orchestration-schema": "static-1.35302",
  "crm-record-cards-service-types": "static-1.3514",
  "highcharts": "static-8.101",
  "trellis-story-utils": "static-1.4403",
  "storybook-react": "static-1.30",
  "hub-http-contrib": "static-1.2926",
  "interframe": "static-3.4646",
  "tinymce-data": "static-1.40097",
  "ui-addon-sales-email": "static-1.5095",
  "codemirror": "static-5.92",
  "layout-dnd-components": "static-1.12213",
  "layout-dnd-utils": "static-1.11188",
  "react-codemirror": "static-1.10507",
  "ui-brand-identity-lib": "static-1.14603",
  "NamespacedHubStyle": "static-2.8972",
  "outpost": "static-1.4080",
  "flux-actions": "static-1.323",
  "integrations-error-boundary-lib": "static-1.13120",
  "integrations-tracking-lib": "static-1.5478",
  "native-integrations-shared-strings": "static-1.7670",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10257",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.324",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68009",
  "layout-data-lib": "static-1.9513",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2889",
  "advanced-menus-core": "static-1.14943",
  "advanced-menus-lib": "static-1.11909",
  "ExportDialog": "static-6.10271",
  "ui-memberships-settings-lib": "static-1.33699",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14942",
  "simple-menus-lib": "static-1.16459"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1896",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "data-fetching-client": "/data-fetching-client/static-1.9559",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.416",
  "growth-payments-core": "/growth-payments-core/static-1.24995",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5478",
  "hs-test-utils": "/hs-test-utils/static-1.7895",
  "hub-http": "/hub-http/static-1.6102",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9687",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17876",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyleTokens": "/HubStyleTokens/static-2.11329",
  "I18n": "/I18n/static-7.1598",
  "immutable": "/immutable/static-2.76",
  "jasmine-runner": "/jasmine-runner/static-1.6353",
  "payment-link-components": "/payment-link-components/static-1.23182",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6844",
  "quartz-core": "/quartz-core/static-1.6063",
  "react": "/react/static-7.183",
  "react-colorpicker": "/react-colorpicker/static-2.10093",
  "react-dlb": "/react-dlb/static-1.75",
  "react-utils": "/react-utils/static-2.5251",
  "rich-text-lib": "/rich-text-lib/static-1.19625",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17803",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5467",
  "UIComponents": "/UIComponents/static-3.8276",
  "foundations-assets": "/foundations-assets/static-1.4726",
  "foundations-components": "/foundations-components/static-1.7684",
  "foundations-theming": "/foundations-theming/static-1.4295",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2011",
  "framer-motion": "/framer-motion/static-1.69",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9522",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "portals-platform-lib": "/portals-platform-lib/static-1.671",
  "quartz-config": "/quartz-config/static-1.622",
  "quartz-routing": "/quartz-routing/static-1.274",
  "quick-fetch": "/quick-fetch/static-1.3817",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16537",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.8028",
  "styled-components": "/styled-components/static-2.87",
  "tanstack-table": "/tanstack-table/static-1.52",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4652",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9428",
  "usage-tracker": "/usage-tracker/static-1.7219",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5636",
  "usage-tracker-core": "/usage-tracker-core/static-1.7069",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3310",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3121",
  "quartz-webpack": "/quartz-webpack/static-1.3068",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.79",
  "customer-data-objects": "/customer-data-objects/static-1.7537",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7807",
  "laboratory-lib": "/laboratory-lib/static-3.7043",
  "onboarding-scopes": "/onboarding-scopes/static-1.6346",
  "rpc-client-utils": "/rpc-client-utils/static-1.4526",
  "ui-addon-opt": "/ui-addon-opt/static-4.8266",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3006",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "ts-schema": "/ts-schema/static-1.3982",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7573",
  "cssUtils": "/cssUtils/static-1.764",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9708",
  "HubStyle": "/HubStyle/static-2.11637",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.519",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9770",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11030",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8922",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10030",
  "video-components-external": "/video-components-external/static-1.10868",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4208",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5873",
  "customer-data-properties": "/customer-data-properties/static-1.51099",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18144",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4970",
  "onboarding-tours": "/onboarding-tours/static-1.16385",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7972",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3551",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8933",
  "user-context": "/user-context/static-1.4983",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4555",
  "icons": "/icons/static-2.637",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.519",
  "quartz-head": "/quartz-head/static-1.509",
  "quartz-test": "/quartz-test/static-1.519",
  "quartz-tracking": "/quartz-tracking/static-1.223",
  "ui-fonts": "/ui-fonts/static-1.591",
  "usage-tracker-container": "/usage-tracker-container/static-1.7209",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9312",
  "data-token-picker": "/data-token-picker/static-1.16196",
  "FileManagerLib": "/FileManagerLib/static-1.38860",
  "property-translator": "/property-translator/static-1.5293",
  "atom": "/atom/static-1.4953",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "purchase-motions-components": "/purchase-motions-components/static-1.5644",
  "salesImages": "/salesImages/static-1.522",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5167",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.96",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3953",
  "floating-ui": "/floating-ui/static-1.53",
  "react-aria": "/react-aria/static-1.63",
  "trellis-assets": "/trellis-assets/static-1.1469",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2778",
  "foundations-theming-base": "/foundations-theming-base/static-1.3280",
  "stylex": "/stylex/static-1.29",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5633",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4356",
  "react-flip-move": "/react-flip-move/static-1.67",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3749",
  "superstore": "/superstore/static-1.4652",
  "chirp-fetch": "/chirp-fetch/static-1.1765",
  "feedback-loader": "/feedback-loader/static-1.29061",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8619",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8579",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28191",
  "sassPrefix": "/sassPrefix/static-1.153",
  "react-dnd-compat": "/react-dnd-compat/static-1.4502",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2377",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8049",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4534",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11827",
  "content-media-compositions": "/content-media-compositions/static-2.15834",
  "idb-keyval": "/idb-keyval/static-1.41",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4036",
  "magpie-lib": "/magpie-lib/static-1.5477",
  "magpie-types": "/magpie-types/static-1.4937",
  "media-bridge-lib": "/media-bridge-lib/static-1.18716",
  "video-data-lib": "/video-data-lib/static-1.34526",
  "commerce-products-lib": "/commerce-products-lib/static-1.9099",
  "crm-message-bus": "/crm-message-bus/static-1.42636",
  "growth-data-modal": "/growth-data-modal/static-1.5246",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4762",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4599",
  "calling-global-api": "/calling-global-api/static-1.64027",
  "calling-internal-common": "/calling-internal-common/static-1.31185",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65409",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57703",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3701",
  "crm-links": "/crm-links/static-1.6157",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12900",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7965",
  "external-options-client-types": "/external-options-client-types/static-1.4062",
  "file-manager-components": "/file-manager-components/static-1.23220",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6758",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "hs-resources": "/hs-resources/static-1.17",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3493",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4126",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.514",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3593",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48325",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3867",
  "property-value-citations": "/property-value-citations/static-1.1713",
  "pulse": "/pulse/static-1.416",
  "smart-property-lib": "/smart-property-lib/static-1.6343",
  "tiered-pricing": "/tiered-pricing/static-1.980",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10875",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2955",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1551",
  "navigation-components": "/navigation-components/static-1.17584",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.451",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7411",
  "ui-universal-auth": "/ui-universal-auth/static-1.8810",
  "batch-promise": "/batch-promise/static-1.1435",
  "navigation-messaging": "/navigation-messaging/static-1.6911",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17262",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9685",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4905",
  "audio-components": "/audio-components/static-1.5736",
  "FileManagerCore": "/FileManagerCore/static-1.38719",
  "FileManagerImages": "/FileManagerImages/static-1.36371",
  "video-components": "/video-components/static-1.12871",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.709",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4382",
  "nav-client-types": "/nav-client-types/static-1.2240",
  "purchase-motions-api": "/purchase-motions-api/static-1.5647",
  "self-service-api": "/self-service-api/static-1.10128",
  "signup-constants": "/signup-constants/static-1.18617",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7922",
  "trials-service-types": "/trials-service-types/static-1.3783",
  "usage-tracker-public": "/usage-tracker-public/static-1.7030",
  "chatspot-core": "/chatspot-core/static-1.20744",
  "ContentUtils": "/ContentUtils/static-1.67934",
  "copilot-toolkit": "/copilot-toolkit/static-1.10782",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6464",
  "reactive-lib": "/reactive-lib/static-1.607",
  "simple-logging-lib": "/simple-logging-lib/static-1.2934",
  "commerce-permissions": "/commerce-permissions/static-1.648",
  "customer-data-tracking": "/customer-data-tracking/static-1.6766",
  "products-iframe-lib": "/products-iframe-lib/static-1.7584",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10069",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.221",
  "calling-error-reporting": "/calling-error-reporting/static-1.31191",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10922",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6425",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.525",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7132",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8850",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4046",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3912",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6663",
  "persist-promise": "/persist-promise/static-1.3592",
  "directed-graph": "/directed-graph/static-1.821",
  "event-emitter": "/event-emitter/static-1.831",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5446",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9770",
  "fsm": "/fsm/static-1.3617",
  "policy-lib": "/policy-lib/static-1.6664",
  "react-tinymce": "/react-tinymce/static-1.54886",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9833",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54012",
  "tinymce-plugins": "/tinymce-plugins/static-1.57126",
  "tinymce-themes": "/tinymce-themes/static-1.55982",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1579",
  "user-context-client": "/user-context-client/static-1.4495",
  "nest": "/nest/static-1.105",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.605",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4415",
  "video-embed": "/video-embed/static-1.35360",
  "content-icons-ui": "/content-icons-ui/static-1.2191",
  "social-insights-client-types": "/social-insights-client-types/static-1.21701",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3064",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4691",
  "integrations-lib": "/integrations-lib/static-1.15705",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4146",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35302",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3514",
  "highcharts": "/highcharts/static-8.101",
  "trellis-story-utils": "/trellis-story-utils/static-1.4403",
  "storybook-react": "/storybook-react/static-1.30",
  "hub-http-contrib": "/hub-http-contrib/static-1.2926",
  "interframe": "/interframe/static-3.4646",
  "tinymce-data": "/tinymce-data/static-1.40097",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5095",
  "codemirror": "/codemirror/static-5.92",
  "layout-dnd-components": "/layout-dnd-components/static-1.12213",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11188",
  "react-codemirror": "/react-codemirror/static-1.10507",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14603",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8972",
  "outpost": "/outpost/static-1.4080",
  "flux-actions": "/flux-actions/static-1.323",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13120",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5478",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7670",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10257",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.324",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68009",
  "layout-data-lib": "/layout-data-lib/static-1.9513",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2889",
  "advanced-menus-core": "/advanced-menus-core/static-1.14943",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11909",
  "ExportDialog": "/ExportDialog/static-6.10271",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33699",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14942",
  "simple-menus-lib": "/simple-menus-lib/static-1.16459"
}
};
